import { updateItems } from '@/mocks/homeData';

const tagColors: Record<string, string> = {
  '最新': 'bg-primary-100 text-primary-700',
  '热门': 'bg-accent-100 text-accent-700',
  '新作': 'bg-secondary-100 text-secondary-700',
  '公告': 'bg-background-200 text-foreground-600',
  '番外': 'bg-primary-100/70 text-primary-600',
  '精选': 'bg-accent-100/70 text-accent-600',
  '重磅': 'bg-accent-100 text-accent-700',
};

export default function SectionUpdates() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            更新动态
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            最新漫画章节更新、新作上架和平台公告，追更党不容错过的一手资讯
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 border-l-2 border-background-300/60">
            {updateItems.map((item, idx) => (
              <div
                key={`${item.title}-${idx}`}
                className={`relative pb-6 md:pb-8 ${
                  idx === updateItems.length - 1 ? 'pb-0' : ''
                }`}
              >
                <div className="absolute -left-[25px] top-0 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-100"></div>
                <div className="flex items-start gap-3 flex-wrap">
                  <span className="text-xs text-foreground-500 whitespace-nowrap mt-0.5">
                    {item.date}
                  </span>
                  {item.tag && (
                    <span
                      className={`inline-block px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
                        tagColors[item.tag] || 'bg-background-200 text-foreground-600'
                      }`}
                    >
                      {item.tag}
                    </span>
                  )}
                </div>
                <h3 className="text-sm md:text-base font-heading text-foreground-900 mt-1.5 mb-1">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}